var map = {
	"./AIUnscramble/Alarm (警报)@2x.png": "607e",
	"./AIUnscramble/Attention (注意)@2x.png": "a792",
	"./AIUnscramble/Down.png": "b3d1",
	"./AIUnscramble/Keyboard.png": "0d63",
	"./AIUnscramble/Tips-one (提示)@2x.png": "655b",
	"./AIUnscramble/Volume-notice.png": "cb63",
	"./AIUnscramble/aiIcon.png": "43c4",
	"./AIUnscramble/ai_icon.png": "a5a7",
	"./AIUnscramble/icon_2.png": "8d9f",
	"./AIUnscramble/pause.png": "25a7",
	"./AIUnscramble/play.png": "30ec",
	"./AIUnscramble/replay.png": "5ce2",
	"./AIUnscramble/send.png": "798a",
	"./AIUnscramble/up.png": "307a",
	"./AIUnscramble/关闭声音.png": "102d",
	"./AIUnscramble/图标-AI小助手2.png": "8cc1",
	"./AIUnscramble/图标-AI小助手@2x.png": "79e8",
	"./AIUnscramble/图标—日光浴@2x.png": "f480",
	"./AIUnscramble/图标—睡眠@2x.png": "00f5",
	"./AIUnscramble/图标—运动@2x.png": "d4a0",
	"./AIUnscramble/语音.png": "8d0e",
	"./Frame.png": "44c0",
	"./Indicator.png": "a568",
	"./Trace.png": "9d78",
	"./back.png": "336c",
	"./bg-01.png": "a2d0",
	"./bg-old.png": "3fb2",
	"./bg.png": "d68e",
	"./cite.png": "2ec7",
	"./close.png": "cd5c",
	"./down.png": "4ee8",
	"./drinking.png": "7907",
	"./fx.png": "a6fe",
	"./high.png": "de40",
	"./logo.png": "cf05",
	"./low.png": "e9a3",
	"./more.png": "69f5",
	"./motion.png": "a95d",
	"./pointer01.png": "9af6",
	"./pointer02.png": "9800",
	"./question.png": "61e2",
	"./questionEmpty.png": "55c6",
	"./question_old.png": "ee02",
	"./recuperate/header.png": "f65f",
	"./ring.png": "2d4a",
	"./scheme/1.png": "6316",
	"./scheme/2.png": "9c60",
	"./scheme/3.png": "4980",
	"./scheme/4.png": "4a8e",
	"./sex/1-old.png": "fce0",
	"./sex/1.png": "6f8d",
	"./sex/2-old.png": "1994",
	"./sex/2.png": "6a5d",
	"./sleep.png": "294b",
	"./types/1.png": "10d1",
	"./types/2.png": "03cd",
	"./types/3.png": "e8f4",
	"./up.png": "8219",
	"./yy-bg.png": "1efa",
	"./图层 733 1@2x.png": "9cd1",
	"./图标-检测要求.png": "541b6",
	"./图标-检测项目.png": "541b",
	"./图标-红点@2x.png": "4577",
	"./图标-营养均衡.png": "4409",
	"./图标-营养失衡.png": "4409c",
	"./图标-进入.png": "0e05",
	"./图标-饮食建议.png": "d1bf",
	"./圆形图标.png": "9a75",
	"./插画-评估报告@2x.png": "7c18",
	"./进入@2x.png": "500d",
	"./食物警示图标.png": "4f0c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9e01";